import React, { useMemo } from 'react'
import { Calendar, MessageCircle, Users } from 'react-feather'
import { format, isValid } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'
import './ReviewPanel.scss'

function contactPhone(c) {
  if (!c) return ''
  return c.fone || c.phone || ''
}

function buildPreviewText(message, contact, extraVars) {
  if (!contact) return message || ''
  let s = message || ''
  s = s.replace(/{nome}/gi, contact.name || '')
  s = s.replace(/{telefone}/gi, contactPhone(contact))
  s = s.replace(/{Nome do participante}/gi, contact.name || '')
  extraVars.forEach((v) => {
    const val = contact[v.value]
    if (val === undefined || val === null) return
    const re = new RegExp(`\\{${v.value}\\}`, 'g')
    s = s.replace(re, String(val))
  })
  return s
}

export function ReviewPanel({
  campaignName,
  contactCount,
  message,
  scheduleLabel,
  sampleContacts,
  extraVariables
}) {
  const first = sampleContacts[0]
  const preview = useMemo(
    () => buildPreviewText(message, first, extraVariables || []),
    [message, first, extraVariables]
  )

  return (
    <div className="review-panel">
      <div className="review-panel__summary">
        <div className="review-panel__summary-row">
          <span className="review-panel__summary-label">Campanha</span>
          <strong className="review-panel__summary-value">{campaignName || '—'}</strong>
        </div>
        <div className="review-panel__summary-row">
          <Users size={16} aria-hidden />
          <span className="review-panel__summary-label">Contatos</span>
          <strong className="review-panel__summary-value">
            {contactCount} {contactCount === 1 ? 'contato' : 'contatos'}
          </strong>
        </div>
        <div className="review-panel__summary-row">
          <Calendar size={16} aria-hidden />
          <span className="review-panel__summary-label">Envio</span>
          <span className="review-panel__summary-value">{scheduleLabel}</span>
        </div>
      </div>

      <div className="review-panel__wa-wrap">
        <div className="review-panel__wa-header">
          <MessageCircle size={18} aria-hidden />
          <span>Pré-visualização (primeiro contato)</span>
        </div>
        <div className="review-panel__wa-bubble">
          <p className="review-panel__wa-text">{preview || '—'}</p>
          <span className="review-panel__wa-time">
            {format(new Date(), 'HH:mm', { locale: ptBR })}
          </span>
        </div>
      </div>

      <div className="review-panel__sample">
        <h4 className="review-panel__sample-title">Amostra (3 primeiros)</h4>
        <ul className="review-panel__sample-list">
          {sampleContacts.slice(0, 3).map((c, i) => (
            <li key={i} className="review-panel__sample-item">
              <span className="review-panel__sample-name">{c.name || '—'}</span>
              <span className="review-panel__sample-phone">
                {contactPhone(c) || '—'}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export function formatScheduleLabel(momento, horaEnvioDatePicker) {
  if (momento === 'now') return 'Envio imediato'
  if (horaEnvioDatePicker && isValid(horaEnvioDatePicker)) {
    return format(horaEnvioDatePicker, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR })
  }
  return 'Agendado'
}
